import { Widget } from "blue-widgets";
import Expandable from "./expandable";

class HeaderDropdown extends Widget {
  constructor(el) {
    super(el);
    this.dropdown = new Expandable(el);
    this.hideContent = this.hideContent.bind(this);
    this.handleBodyClick = this.handleBodyClick.bind(this);
    this.handleExpandableToggled = this.handleExpandableToggled.bind(this);
    this.positionContent = this.positionContent.bind(this);
    this.computedStyle = window.getComputedStyle(this.dropdown.content);
    this.el.addEventListener("close-expandable", this.hideContent);
    this.el.addEventListener(
      "expandable-toggled",
      this.handleExpandableToggled,
      false
    );
    this.arrowOffset = 48;
  }

  handleExpandableToggled() {
    const isOpen = this.el.classList.contains("isOpen");
    if (isOpen === true) {
      window.addEventListener("scroll", this.hideContent, false);
      window.addEventListener("click", this.handleBodyClick, false);
      window.addEventListener("resize", this.hideContent, false);
      this.positionContent();
    }
  }

  positionContent() {
    this.dropdown.content.style = "";
    const padding = 80;
    const contentRect = this.dropdown.content.getBoundingClientRect();
    const triggerRect = this.el.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const contentWidthHalf = contentRect.width / 2;
    const overflowLeft = contentRect.left - contentWidthHalf < 0;
    const overflowRight =
      contentRect.right - contentWidthHalf + padding > viewportWidth;

    if (!overflowLeft && !overflowRight) {
      this.dropdown.content.style = `left: ${
        triggerRect.left + this.arrowOffset
      }px; right: auto; transform: translateX(-50%);`;
      return;
    }

    if (overflowLeft && overflowRight) {
      this.dropdown.content.style = "left: 20px; right: auto;";
      return;
    }
    if (overflowLeft) {
      this.dropdown.content.style = "left: 20px; right: auto;";
    }

    if (overflowRight) {
      this.dropdown.content.style = "left: auto; right: 20px;";
    }
  }

  hideContent() {
    this.el.classList.remove("isOpen");
    this.dropdown.trigger.setAttribute("aria-expanded", "false");
    this.childExpanded = this.dropdown.trigger.querySelector("[aria-expanded]");
    if (this.childExpanded) {
      this.childExpanded.setAttribute("aria-expanded", "false");
    }

    if (this.dropdown.content) {
      this.dropdown.toggleContentTabindexs("-1");
      this.dropdown.content.setAttribute("aria-hidden", "true");
      this.dropdown.content.style = "";
    }
    window.removeEventListener("scroll", this.hideContent, false);
    window.removeEventListener("resize", this.hideContent, false);
  }

  handleBodyClick(e) {
    const isOutsideParent = e.target.closest(".header__dropdown") === null;
    if (isOutsideParent) {
      this.hideContent();
      window.removeEventListener("click", this.bodyClickHandler, false);
    }
  }
}

export default HeaderDropdown;
